export class DocTypes {
    id: string;
    description: string;
}

export enum DocStatusType {
    docLoaded = <any>'DocLoaded',
    docPicked = <any>'DocPicked',
    docError = <any>'DocError',
    docCleared = <any>'DocCleared',
    docSizeError = <any>'DocSizeError',
}

export class DocumentSelected {
    data: any;
    status: DocStatusType;
    action?: string;
}

export class DocDetailsRequestModel {
    Name: string;
    Data: string;
    DocumentTypeId: string | null;
    Comments: string;
    UploadSuccess?: boolean;
    ContentType?: string | null;
}

export class FileData {
    Name: string;
    ContentType: string;
    Data: any;
}

export class UploadFileData {
    Name: string;
    Data: any;
    Comments: string;
    DocumentTypeId: string;
    ContentType: string;
    TotalFileSizeExceeded?: boolean;
    UploadedSuccessfully?: boolean;
}

export class DocDetailsRequest {
    Name: string;
    Data: any;
    Comments: string;
    DocumentTypeId: string;
    UploadSuccess?: boolean;
}

export enum NavigationPages {
    AccountMenu = 'fromAccountMenu',
}
